export default "__VITE_ASSET__XTsnZvkN__"